// @flow

function delay() {
  let timer: TimeoutID;

  return (callback: Function, ms: number = 1000): TimeoutID => {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
    return timer;
  };
};

export default delay;
